import React, {useState, useEffect} from 'react';
import {Route} from 'react-router-dom';
import {EdapProvider} from '@homeaway/react-event-tracking';
import {ParallaxProvider} from 'react-scroll-parallax';
import SiteHeader from '@homeaway/react-site-header';
import SiteFooter from '@homeaway/react-site-footer';
import {TranslationContext} from '../../../utils/context.js';
import WelcomePage from 'pages/WelcomePage/WelcomePage';
import OpeningsPage from 'pages/OpeningsPage/OpeningsPage';
import JobPage from 'pages/JobPage/JobPage';
import './PageLayout.less';
import WithApiData from '../../../api/WithApiData';

const PageLayout = ({match, data, children}) => {
    const [isClient, updateIsClient] = useState(false);

    useEffect(() => {
        if (!isClient) {
            updateIsClient(true);
        }
    });

    return (
        <EdapProvider>
            {children}
            <SiteHeader data={data.header} shouldFetchData={false} />
            <div className="careers-page">
                <ParallaxProvider>
                    <TranslationContext.Provider value={data.translations}>
                        <Route
                            exact
                            path={`${match.path}`}
                            render={(routeProps) => (
                                <WithApiData
                                    {...routeProps}
                                    endpoint={'/careers/api/careers'}
                                    component={WelcomePage}
                                />
                            )}
                        />
                        <Route
                            path={`${match.path}/openings`}
                            render={(routeProps) => (
                                <WithApiData
                                    {...routeProps}
                                    endpoint={'/careers/api/openings'}
                                    component={OpeningsPage}
                                />
                            )}
                        />
                        <Route
                            path={`${match.path}/job/:id`}
                            render={(routeProps) => (
                                <WithApiData
                                    {...routeProps}
                                    endpoint={'/careers/api/job/:id'}
                                    component={JobPage}
                                />
                            )}
                        />
                        <Route
                            path={`${match.path}/university`}
                            component={() => {
                                if (isClient) {
                                    window.location.href =
                                        'https://lifeatexpedia.com/early-talent';
                                }
                                return null;
                            }}
                        />
                    </TranslationContext.Provider>
                </ParallaxProvider>
            </div>
            <SiteFooter data={data.footer} shouldFetchData={false} />
        </EdapProvider>
    );
};

export default PageLayout;
